import { AfterViewInit, Component, HostListener, ViewEncapsulation } from '@angular/core';
import { isTargetClickable, setWhiteBackgroundIfNothingSet } from '@modules/cursors/helpers/helpers';

@Component({
  selector: 'app-dot-cursor',
  template: `
    <div class="cursor">
      <div class="dot"></div>
    </div>`,
  styles: [`
    body, body * {
      cursor: none !important;
    }

    .cursor {
      pointer-events: none;
    }

    .dot {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
      transition-duration: 0s !important;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: rgba(57, 57, 57, 0.5);
      box-sizing: border-box;
      border: 2px solid #fff;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class DotCursorComponent implements AfterViewInit {
  private dot: HTMLElement;
  private mouseX = 0;
  private mouseY = 0;
  isBig = false;

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e: any): void {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.isBig = isTargetClickable(e.target);
  }

  ngAfterViewInit(): void {
    setWhiteBackgroundIfNothingSet();
    this.dot = document.querySelector('.cursor .dot') as HTMLElement;

    requestAnimationFrame(() => this.animate());
  }

  private animate(): void {
    if (this.dot) {
      this.dot.style.transform = `translate(${this.mouseX - 10}px, ${this.mouseY - 10}px)`;
    }

    requestAnimationFrame(() => this.animate());
  }

}
